// Static demo content for User Manuals. Integrate with API later.

export const userManuals = [
	{
		slug: 'getting-started',
		title: 'طريقة اضافة اختيارات للمنتج (مثل: الحجم،المقاس، اللون)',
		summary: 'شرح مفصل عن كيفية اضافة اختيارات للمنتج مع وجود سعر و كمية لكل اختيار.',
		image: '/static/illustrations/illustration_rocket.png',
		updatedAt: '2025-12-01',
		content: [
			'Welcome to Vetrina CMS! This guide helps you get up and running fast.',
			'Start by completing your site setup from the Setup page. Configure your store name, branding, and basic preferences.',
			'Next, add your first products: go to Products → Create, fill in details like title, price, stock, and images.',
			'Invite team members under Admins to collaborate on orders, products, and settings.',
			'Finally, explore the dashboard widgets for insights on orders, inventory, and customer activity.',
		],
	},
	{
		slug: 'orders-management',
		title: 'طريقة الربط مع شركة درب السبيل',
		summary: 'Learn how to view, update, and fulfill orders effectively.',
		image: '/static/illustrations/illustration_login.png',
		updatedAt: '2025-11-15',
		content: [
			'Find all orders under the Orders section. Use filters to narrow by status, date, and fulfillment.',
			'Open any order to update items, customer details, or shipping info. Use Exchange when replacing items.',
			'Switch between Online and Cashier orders for different workflows and reporting needs.',
			'Keep notes on each order to streamline handoffs between team members.',
		],
	},
	{
		slug: 'inventory-tracking',
		title: 'طريقة تفعيل الدفع الالكتروني',
		summary: 'Best practices to keep stock levels accurate and avoid overselling.',
		image: '/static/illustrations/items-selection.png',
		updatedAt: '2025-10-04',
		content: [
			'Track stock changes under Product Inventory Changes for transparency and audits.',
			'Use Out-of-Stock page to quickly identify items needing restock or unpublish them temporarily.',
			'Bulk update quantities when receiving new shipments to keep inventory consistent across channels.',
		],
	},
	{
		slug: 'shipping',
		title: 'Shipping & Delivery Methods',
		summary: 'Configure delivery providers and set up districts, fees, and rules.',
		image: '/static/backgrounds/gradientwavebackground.png',
		updatedAt: '2025-09-20',
		content: [
			'Add delivery methods and customize fees per district to optimize costs and speed.',
			'Integrate with providers like DHL to automate label creation from the order page.',
			'Keep provider settings up to date to prevent unexpected charges or delays.',
		],
	},
	{
		slug: 'billing',
		title: 'Billing & Invoices',
		summary: 'Manage invoices, subscriptions, and payment provider settings.',
		image: '/static/illustrations/illustration_register.png',
		updatedAt: '2025-08-12',
		content: [
			'Access invoices from the Invoices section for download and record-keeping.',
			'Update payment methods (Paypal, Bunq) under Plugins settings to ensure smooth checkout.',
			'Review finance reports regularly to track revenue, discounts, and taxes.',
		],
	},
];

export function findManualBySlug(slug) {
	return userManuals.find((m) => m.slug === slug);
}
